import { render, staticRenderFns } from "./MentoresLista.vue?vue&type=template&id=319d7bde&"
import script from "./MentoresLista.vue?vue&type=script&lang=js&"
export * from "./MentoresLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports